import { Injectable } from '@angular/core';
import { configurationPropertyElementParse } from "../../configurationProperty/elementParseConfiguration";
import {
    arrayIsSet,
    fetchObject$,
    GlobalVariablesService, NOTDEFINEDVALUE, PaginationParserequestType,
    paramsParseQuery,
    stringIsSet
} from "./global-variables.service";
import { isNotNullOrUndefined } from "../../providers/service/global-variables.service";
import { catchError, delay, expand, map, switchMap } from "rxjs/operators";
import { BehaviorSubject, EMPTY, forkJoin, from, Observable, of, Subject, Subscription, throwError } from "rxjs";
import { LocalStorageService } from "./local-storage.service";
import * as Parse from "parse";
import { fromPromise } from "rxjs/internal-compatibility";
import { DetailsType, ElementParse, ElementParse_v2 } from "../../ParseClass/Element.Parse";
import { ProgettiParse } from "../../ParseClass/Progetti.Parse";
import { ElementTypeCategoryEnum, ElementTypeParse } from "../../ParseClass/ElementType.Parse";
import {
    getElementByKeyName,
    isPointerConfigurationElement,
    typeFormValue
} from "../../configurationProperty/configurationPropertyUtils";
import { ImageService } from "./image.service";
import {
    AutocompleteUpdateElementValueType
} from "../../components/pop-up-component/update-element/update-element.component";
import { ParseApiService } from "./parse-api.service";
import { IotDevicesParse } from "../../ParseClass/Iotdevices.Parse";
import { NotificationParse } from "../../ParseClass/notificationParse";

export const CategoryElementType = {
    ambientSensor: "AMBIENT_SENSOR",
    battery: "BATTERY",
    boiler: "BOILER",
    caldaia: "CALDAIA",
    light: "LIGHT",
    meter: "METER",
    relay: "RELAY",
    shutter: "SHUTTER",
    thermostats: "THERMOSTATS",
    virtualSensor: "VIRTUAL_SENSOR"
}
export type TypeCategoryElementType = typeof ElementTypeCategoryEnum[(keyof typeof ElementTypeCategoryEnum)];

@Injectable({
    providedIn: 'root'
})
export class ElementPageService {

    public configuration = configurationPropertyElementParse;
    private subscriptionChangeProject: Subscription | undefined;
    private subscriptionWeb_getAllElementsRevealed: Subscription | undefined;
    private subscriptionWeb_getKpiElements: Subscription | undefined;
    public updatingValue = new Subject<boolean>()

    private _allElements = new BehaviorSubject<ElementParse_v2[] | undefined>(undefined);
    public allElements$: Observable<ElementParse_v2[] | undefined> = this._allElements.asObservable();
    public allElementsEnviromentFloorRoom$: Observable<AutocompleteUpdateElementValueType> = this.allElements$.pipe(
        map(elements => {
            let environments: string[] | undefined;
            let floors: number[] | undefined;
            let rooms: string[] | undefined;
            if (arrayIsSet(elements)) {
                elements.forEach(el => {
                    const environment = el.environment;
                    const floor = el.floor;
                    const room = el.room;

                    if (environment != null && environment != NOTDEFINEDVALUE.environment) {
                        if (!arrayIsSet(environments)) {
                            environments = [environment];
                        } else {
                            if (!environments.includes(environment)) {
                                environments.push(environment)
                            }
                        }
                    }
                    if (floor != null && (floor as any) != NOTDEFINEDVALUE.floor) {
                        if (!arrayIsSet(floors)) {
                            floors = [floor];
                        } else {
                            if (!floors.includes(floor)) {
                                floors.push(floor)
                            }
                        }
                    }
                    if (room != null && room != NOTDEFINEDVALUE.room) {
                        if (!arrayIsSet(rooms)) {
                            rooms = [room];
                        } else {
                            if (!rooms.includes(room)) {
                                rooms.push(room)
                            }
                        }
                    }
                })
            }
            return { environment: environments, floor: floors, room: rooms } as AutocompleteUpdateElementValueType
        })
    );

    _typeElement: ElementTypeParse[] | undefined;


    constructor(private globalVariable: GlobalVariablesService,
        private localStorageService: LocalStorageService,
        private parseApiService: ParseApiService
    ) {
    }


    get progetto() {
        return this.globalVariable.currentProject
    }

    initChangeProject() {
        this.updatingValue.next(true);
        if (!isNotNullOrUndefined(this.subscriptionChangeProject)) {
            this.subscriptionChangeProject = this.localStorageService.changeProject$.asObservable().pipe(
                switchMap((projectId) => {
                    this.updatingValue.next(true);
                    if (projectId !== undefined) {
                        return this.getAllElements$(projectId).pipe(
                            map((elements) => {
                                return { error: false, devices: elements }
                            })
                        )
                    } else {
                        return of({ error: 'nessun_project_id', devices: [] })
                    }
                })
            )
                .subscribe(updated => {
                    this._typeElement = undefined;
                    if (updated.error) {
                        this.setAllElements([]);
                    } else if (updated.devices) {
                        this.setAllElements(updated.devices as ElementParse_v2[]);
                    }
                    this.updatingValue.next(false);
                }, error => {
                    this._typeElement = undefined;
                    this.setAllElements([]);
                    this.updatingValue.next(false)
                })
        }
        this.localStorageService.projectId = this.localStorageService.projectId
    }

    destroyChangeProject() {
        if (this.subscriptionChangeProject != null) {
            this.subscriptionChangeProject.unsubscribe();
            this.subscriptionChangeProject = undefined;
        }
    }

    getElement(objectId: string | undefined = undefined): Observable<ElementParse[]> {
        const projectId = (isNotNullOrUndefined(objectId)) ? objectId : this.globalVariable.currentProject?.objectId;
        const progetto = new ProgettiParse();
        progetto.objectId = projectId!;
        const query = new ElementParse().query()
        query.equalTo('progetto', progetto);
        query.include('type');
        return fromPromise(query.find()).pipe(map(elements => {
            return (elements as any[])?.map((el: any) => {
                if (el.type && el.type.objectId) {
                    const elementType = new ElementTypeParse();
                    elementType.objectId = el.type.objectId
                    el.type = elementType;
                }
                return el
            })
        }))
    }

    getAllElements$(progettoId: string | undefined = undefined, includeTypes = false) {
        const projectId = stringIsSet(progettoId) ? progettoId : this.globalVariable.currentProject?.objectId;
        const data: any = { projectId, includeTypes }
        const requestParams: Record<string, any> = paramsParseQuery(data)
        return fromPromise(Parse.Cloud.run('getAllElements', requestParams)).pipe(
            map((deviceType) => {
                return (deviceType as any[]).map(dev => {
                    const element = new ElementParse_v2().fromJson(dev);
                    return element
                }
                )
            })
        ) as Observable<ElementParse_v2[]>;
    }

    web_getAllElementsRevealed(progettoId: string | undefined = undefined) {
        const projectId = stringIsSet(progettoId) ? progettoId : this.globalVariable.currentProject?.objectId;
        const data: any = { projectId }
        const requestParams: Record<string, any> = paramsParseQuery(data)
        return fromPromise(Parse.Cloud.run('web_getAllElementsRevealed', requestParams)).pipe(
            map((deviceType) => {
                return (deviceType as any[]).map(dev => {
                    const element = new ElementParse_v2().fromJson(dev);
                    return element
                }
                )
            })
        ) as Observable<ElementParse_v2[]>;
    }
    web_getKpiElements$(progettoId: string | undefined = undefined) {
        const projectId = stringIsSet(progettoId) ? progettoId : this.globalVariable.currentProject?.objectId;
        const data: any = { projectId }
        const requestParams: Record<string, any> = paramsParseQuery(data)
        return fromPromise(Parse.Cloud.run('web_getKpiElements', requestParams)).pipe(
            map((deviceType) => {
                return (deviceType as any[]).map(dev => {
                    const element = new ElementParse_v2().fromJson(dev);
                    return element
                }
                )
            })
        ) as Observable<ElementParse_v2[]>;
    }

    initChangeProjectWeb_getAllElementsRevealed() {
        if (!isNotNullOrUndefined(this.subscriptionWeb_getAllElementsRevealed)) {
            this.subscriptionWeb_getAllElementsRevealed = this.localStorageService.changeProject$.asObservable().pipe(
                switchMap((projectId) => {
                    this.updatingValue.next(true);
                    if (projectId !== undefined) {
                        return this.web_getAllElementsRevealed(projectId).pipe(
                            map((elements) => {
                                return { error: false, devices: elements }
                            })
                        )
                    } else {
                        return of({ error: 'nessun_project_id', devices: [] })
                    }
                })
            )
                .subscribe(updated => {
                    this._typeElement = undefined;
                    if (updated.error) {
                        this.globalVariable.allElementsRevealed.set([])
                    } else if (updated.devices) {
                        this.globalVariable.allElementsRevealed.set(updated.devices as ElementParse_v2[])
                    }
                    this.updatingValue.next(false);
                }, error => {
                    this.globalVariable.allElementsRevealed.set([])
                    this.updatingValue.next(false)
                })
        }
        this.localStorageService.projectId = this.localStorageService.projectId

    }

    destroyChangeProjectWeb_getAllElementsRevealed() {
        if (this.subscriptionWeb_getAllElementsRevealed != null) {
            this.subscriptionWeb_getAllElementsRevealed.unsubscribe();
            this.subscriptionWeb_getAllElementsRevealed = undefined;
        }
    }
    initChangeProjectWeb_getKpiElements() {
        if (!isNotNullOrUndefined(this.subscriptionWeb_getKpiElements)) {
            this.subscriptionWeb_getKpiElements = this.localStorageService.changeProject$.asObservable().pipe(
                switchMap((projectId) => {
                    this.updatingValue.next(true);
                    if (projectId !== undefined) {
                        return this.web_getKpiElements$(projectId).pipe(
                            map((elements) => {
                                return { error: false, devices: elements }
                            })
                        )
                    } else {
                        return of({ error: 'nessun_project_id', devices: [] })
                    }
                })
            )
                .subscribe(updated => {
                    this._typeElement = undefined;
                    if (updated.error) {
                        this.globalVariable.allKpiElements.set([])
                    } else if (updated.devices) {
                        this.globalVariable.allKpiElements.set(updated.devices as ElementParse_v2[])
                    }
                    this.updatingValue.next(false);
                }, error => {
                    this.globalVariable.allKpiElements.set([])
                    this.updatingValue.next(false)
                })
        }
        this.localStorageService.projectId = this.localStorageService.projectId

    }

    destroyChangeProjectWeb_getKpiElements() {
        if (this.subscriptionWeb_getKpiElements != null) {
            this.subscriptionWeb_getKpiElements.unsubscribe();
            this.subscriptionWeb_getKpiElements = undefined;
        }
    }

    fetchElement() {
        this.updatingValue.next(true);
        this._typeElement = undefined;
        this.getAllElements$().subscribe(
            element => {
                this.setAllElements(element);
                this.updatingValue.next(false);
            }, error => {
                this.updatingValue.next(false);
            }
        )

    }


    public setAllElements(value: ElementParse_v2[]) {
        this._allElements.next(value)
    }

    getParseImage(nome: string, base64: string) {
        return new Parse.File(nome, { base64: base64 }, "image/jpg");
    }


    public updateElement(element: ElementParse_v2 | undefined, values: {
        [k: string]: any
    }): Observable<ElementParse_v2> {
        const params = Object.keys(values).reduce((prev, key) => {
            if (values[key] != null) {
                let valueToSave
                const elementConfiguration = getElementByKeyName(key, this.configuration)
                if (isPointerConfigurationElement(elementConfiguration!)) {
                    if (elementConfiguration?.pointer?.getValueToSave) {
                        valueToSave = elementConfiguration?.pointer?.getValueToSave!(values[key]);
                    } else {
                        valueToSave = values[key];
                    }
                } else if (elementConfiguration?.typeForm == typeFormValue.IMAGE) {

                    let name;
                    let base64;
                    if (values[key].file && typeof values[key].file === 'string') {
                        base64 = values[key].file.replace(/^data:image\/[a-z]+;base64,/, "")
                    }
                    if (base64 != null) {
                        if (values[key].name && typeof values[key].name === 'function') {
                            name = values[key].name();
                        } else if (values[key].name) {
                            name = values[key].name;
                        } else {
                            name = 'image.jpg'
                        }
                        console.log('Saving image with name:', name, base64);
                        valueToSave = {
                            name,
                            base64
                        }
                    }
                } else if (elementConfiguration?.typeForm == typeFormValue.FILE) {
                    valueToSave = {
                        name: values[key].name,
                        base64: values[key].file.replace(/^data:image\/[a-z]+;base64,/, "")
                    }
                } else if (elementConfiguration?.typeForm == typeFormValue.GEO_POINT) {
                    valueToSave = { latitude: values[key].latitude, longitude: values[key].longitude, }
                } else {
                    valueToSave = values[key]
                }
                prev[key] = valueToSave;
            } else {
                prev[key] = null;
            }
            return prev;
        }, {} as any)
        if (element != null) {
            params['objectId'] = element.objectId
            const requestParams: Record<string, any> = paramsParseQuery({ element: params })
            return from(Parse.Cloud.run('updateElement', requestParams)).pipe(
                switchMap((updateValues) => {
                    return fetchObject$({
                        objectId: element.objectId,
                        className: new ElementParse_v2().className
                    } as any).pipe(
                        map(el => {
                            return el!
                        })
                    )
                }),
            )
        } else {
            const requestParams: Record<string, any> = paramsParseQuery({
                element: params,
                progettoId: this.progetto?.objectId
            })
            return from(Parse.Cloud.run('createElement', requestParams)).pipe(
                switchMap((id) => {
                    return fetchObject$({ objectId: id, className: new ElementParse_v2().className });
                }),
                map(v => {
                    return new ElementParse_v2().fromJson(v)
                })
            )
        }

    }

    public addElement(element: ElementParse_v2, currentElement: ElementParse_v2[], addToIndex: undefined | number = undefined) {
        let elements = arrayIsSet(currentElement) ? [...currentElement] : []
        const index = currentElement.findIndex(el => el.objectId == element.objectId)
        if (addToIndex != null && addToIndex >= 0) {
            elements.splice(addToIndex + 1, 0, element);
        } else if (index >= 0) {
            elements.splice(index, 1, element)
            // elements.push(element);
        } else {
            elements.push(element)
        }

        this.setAllElements(elements);
    }

    public removeElement(element: ElementParse_v2, currentElement: ElementParse_v2[]) {
        this.setAllElements(currentElement.filter(el => el.objectId != element.objectId));
    }

    public destroyElement(element: ElementParse | ElementParse_v2) {
        const requestParams: Record<string, any> = paramsParseQuery({ elementId: element.objectId })
        return fromPromise(Parse.Cloud.run('deleteElement', requestParams))
    }

    public destroyElements(elements: (ElementParse_v2)[]): Observable<PaginationParserequestType<(ElementParse_v2) | undefined>> {
        const fetchPage$ = (page = 0) => {
            const element = elements[page];
            const isLast = (page + 1) >= elements.length;
            const progress = Math.ceil((page + 1) / elements.length * 100)
            return this.destroyElement(element).pipe(
                map(not => {
                    return {
                        item: element,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                    }
                })
            )
        }
        return fetchPage$(0).pipe(
            expand(({ nextPage }) => nextPage ? fetchPage$(nextPage) : EMPTY)
        )
    }

    public updateElementsPaginate(elements: ElementParse_v2[], values: { [k: string]: any }): Observable<PaginationParserequestType<ElementParse_v2 | undefined>> {
        const fetchPage$ = (page = 0) => {
            const element = elements[page];
            const isLast = (page + 1) >= elements.length;
            const progress = Math.ceil((page + 1) / elements.length * 100)

            return this.updateElement(element, values).pipe(
                map(updatedElement => {
                    return {
                        item: updatedElement,
                        progress,
                        nextPage: isLast ? undefined : (page + 1),
                        finished: isLast,
                    }
                })
            )
        }
        return fetchPage$(0).pipe(
            expand(({ nextPage }) => nextPage ? fetchPage$(nextPage) : EMPTY)
        )
    }


    getTypeElement(): Observable<ElementTypeParse[]> {
        if (arrayIsSet(this._typeElement)) {
            return of(this._typeElement)
        } else {
            const requestParams: Record<string, any> = paramsParseQuery(undefined)
            return fromPromise(Parse.Cloud.run('getAllElementTypes', requestParams)).pipe(
                map((deviceType) => {
                    this._typeElement = (deviceType as any[]).map(dev => {
                        const element = new ElementTypeParse().fromJson(dev);
                        return element
                    }
                    );
                    return this._typeElement;
                })
            ) as Observable<ElementTypeParse[]>;
        }
    }


    getTraduction(keyName: string, object: any) {
        const element = getElementByKeyName(keyName, this.configuration)
        if (element != null && isPointerConfigurationElement(element)) {
            return element.pointer?.getValue(object);
        } else {
            return object.objectId
        }
    }

    getConfigurationByProject() {
        const config = [...this.configuration].map(el => {
            return { ...el }
        })
        if (this.globalVariable.isPrycamSystem) {
            ['SAP_id', 'prycam_id'].forEach(keyName => {
                const index = config.findIndex(el => el.keyName == keyName)
                if (index >= 0) {
                    config[index].showInForm = true;
                }
            })
        }
        return config
    }


    headerElement = [
        { key: 'name', traductionKey: 'elementParse.name' },
        { key: 'type', traductionKey: 'elementParse.type' },
        { key: 'SAP_id', traductionKey: 'elementParse.SAP_id' },
        { key: 'calculateCounter', traductionKey: 'elementParse.calculateCounter', type: 'BOOL' },
        { key: 'building', traductionKey: 'elementParse.building' },
        { key: 'details', traductionKey: 'elementParse.details', type: 'ARRAY' },
        { key: 'environment', traductionKey: 'elementParse.environment' },
        { key: 'floor', traductionKey: 'elementParse.floor' },
        { key: 'hidden', traductionKey: 'elementParse.hidden', type: 'BOOL' },
        { key: 'lastCounterUpdate', traductionKey: 'elementParse.lastCounterUpdate', type: 'BOOL' },
        { key: 'notes', traductionKey: 'elementParse.notes' },
        { key: 'parentElement', traductionKey: 'elementParse.parentElement' },
        { key: 'progetto', traductionKey: 'elementParse.progetto' },
        { key: 'prycam_id', traductionKey: 'elementParse.prycam_id' },
        { key: 'room', traductionKey: 'elementParse.room' },
    ]

    getRowCsvElement(element: ElementParse_v2, ts: ((key: string) => string)): string {
        let row = ''
        this.headerElement.forEach(keyTad => {
            const jsonExport = element.toJSONExport()
            if (jsonExport[keyTad.key] != null) {
                if (keyTad.type == 'ARRAY') {
                    jsonExport[keyTad.key].forEach((values: DetailsType, index: number) => {
                        if (index > 0) {
                            row += ' - '
                        }
                        row += values.title + ': ';
                        if (values.type == 'BOOL') {
                            row += values.value ? ts('yes') : ts('no');
                        } else {
                            row += values.value
                        }
                    })
                } else if (keyTad.type == 'BOOL') {
                    row += jsonExport[keyTad.key] ? ts('yes') : ts('no');
                } else {
                    row += jsonExport[keyTad.key];
                }
            }
            row += ';'
        })
        return row
    }


    importElements$(elements: any[]): Observable<{ notSavedElements?: any[], savedElements?: any[] }> {
        const requestParams = paramsParseQuery({ elements })
        return this.parseApiService.runCloudFunction('importElements', requestParams,).pipe()
    }

    exportErrorValues(values: any[]) {
        const header = new Set()
        values.forEach(row => {
            Object.keys(row).forEach(key => {
                header.add(key)
            })
        })
        let rows = ''

        header.forEach(key => {
            rows += key + ';';
        })
        rows += '\n'
        values.forEach(value => {
            header.forEach((key: any) => {
                if (value[key]) {
                    rows += value[key]
                }
                rows += ';'
            })
            rows += '\n'
        })
        return rows
    }
}
